import { Skeleton } from '@mui/material'
import React from 'react'

export const ContentLoading = () => {
    return (
        <>
            {
                [1, 2, 3, 4].map(() => (
                    <div className="relative flex flex-col px-2 pt-2 pb-1 w-full bg-white border-[1px] rounded-lg  h-fit  cursor-pointer ">
                        <div className="flex flex-col justify-between   h-full  mt-1 gap-1 w-full">
                            <div className="flex flex-col gap-2">
                                <div className="flex flex-row justify-between items-start pt-1 px-1 rounded-t-lg w-full border-b-2 border-[#ffcb05] h-10 ">
                                    <div className="gap-2 items-center ">
                                        <h5 className="text-sm font-bold  text-[#000000e4]">
                                            <Skeleton width={50} />
                                        </h5>
                                    </div>

                                    <h2 className="text-black mt-0.5 text-end font-medium text-xs truncate">
                                        <Skeleton width={50} />
                                    </h2>
                                </div>

                                <div className="flex flex-col gap-2">
                                    <div className="flex flex-col justify-between gap-2 items-start w-full rounded-lg  ">
                                        <div className="flex flex-col w-full ">

                                            <p className="text-[#000] font-medium text-xs">
                                                <Skeleton width={70} />
                                            </p>
                                        </div>
                                        <div className="flex flex-col ">
                                            <Skeleton width={130} />
                                            <Skeleton width={70} />
                                        </div>

                                        <div className="flex flex-row  gap-3">
                                            <div className="flex flex-col w-full">
                                                <h5 className="text-sm font-bold text-[#000000e4]">
                                                    <Skeleton />
                                                </h5>
                                                <p className="text-[#000] font-medium text-xs truncate">
                                                    <Skeleton width={40} />
                                                </p>
                                            </div>

                                            <div className="flex flex-col w-full">
                                                <Skeleton width={100} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))
            }
        </>
    )
}
